import { useNavigate } from "react-router-dom";
import CustomButton from "../../components/CustomButton";
import PageHeader from "../../components/PageHeader";
import MessagesList from "./MessagesList";

export default function Messages() {
  const navigate = useNavigate()

  return (
    <div className="flex flex-col gap-5">
      <div className="flex flex-col md:flex-row justify-between md:items-start  gap-5">
        <PageHeader title="messaging" />
        <div className="flex justify-end items-end">
        <CustomButton color="bg-primary-500" text="Add New Message"
        onClick={() => navigate("/messages/send-new-message")} />
        </div>
      </div>
      <MessagesList />
    </div>
  );
}
